import React, { useEffect, useRef, useState } from "react";
import { GetGVPCountDashboard } from "../../Apis/DashboardApis/GvpDashbaordApi";
import { Tooltip, Legend, PieChart, Pie, Cell } from 'recharts';
import { GetCirclebyID, GetZone } from "../../Apis/organizationApi";
import { AllShiftMaster } from "../../Apis/shiftMasterApi";
import { toast } from "react-toastify";
import Loader from "../../Common/Loader/loader";
import isGHMC from "../../Common/helper/helpar";

const GvpDashboardReport = () => {
        const isProd = isGHMC();
    const [gvpCountDashboard, setGVPCountDashboard] = useState([]);
    const [isOptionsLoading, setIsOptionsLoading] = useState(true);
    const [startDate, setStartDate] = useState(getStartOfCurrentDate());
    const [endDate, setEndDate] = useState(getCurrentDateTime());
    const [allZones, setAllZones] = useState([]);
    const [allCircles, setAllCircles] = useState([]);
    const [selectedZone, setSelectedZone] = useState(null);
    const [selectedCircles, setSelectedCircles] = useState(null);
    const [circles, setCircles] = useState([]);
    const [selectedShift, setSelectedShift] = useState(null)
    const [shiftData, setShiftData] = useState([]);
    const [pieChartData, setPieChartData] = useState([]);
    const fetchAllDataDetails = async () => {
        try {
            const zonesData = await GetZone();
            setAllZones(zonesData);
            if (selectedZone) {
                const circlesData = await GetCirclebyID(selectedZone);
                setCircles(circlesData);
                setSelectedCircles([]);
                setIsOptionsLoading(false)
            } else {
                setCircles([]);
                setSelectedCircles([]);
            }
        } catch (error) {
            console.error("Error fetching initial data:", error);
        }
    };

    const fetchShift = async () => {
        try {
            const response = await AllShiftMaster();
            setShiftData(response);
        } catch (error) {
        }
    }

    useEffect(() => {
        fetchAllDataDetails();
        fetchShift();
    }, [])
    const handleSearch = async () => {
        try {
            setIsOptionsLoading(true);
            const gvpResponse = await GetGVPCountDashboard(
                startDate,
                endDate,
                selectedZone,
                selectedCircles,
                selectedShift
            );

            const responseData = gvpResponse?.data || [];
            const mergedData = responseData.reduce((acc, curr) => ({ ...acc, ...curr }), {});
            setGVPCountDashboard(mergedData);

            const isEmpty =
                Object.keys(mergedData).length === 0 ||
                Object.values(mergedData).every((val) => val === 0);

            if (!isEmpty) {
                const pieData = Object.keys(mergedData).map((key, index) => ({
                    name: key.replace(/([A-Z])/g, " $1").trim().toUpperCase(),
                    value: mergedData[key],
                    color: COLORS[index % COLORS.length],
                }));
                setPieChartData(pieData);
            } else {
                setPieChartData([]);
            }
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
        } finally {
            setIsOptionsLoading(false);
        }
    };

    useEffect(() => {
        handleSearch()
    }, [])

    useEffect(() => {
        const fetchZones = async () => {
            try {
                const zonesData = await GetZone();
                setAllZones(zonesData);
            } catch (error) {
                console.error("Error fetching zones data:", error);
            }
        };

        fetchZones();
    }, []);

    useEffect(() => {
        const fetchCirclesByZone = async () => {
            try {
                if (selectedZone) {
                    // Fetch circles based on the selected zone ID
                    const circlesData = await GetCirclebyID(selectedZone);
                    setAllCircles(circlesData);
                } else {
                    setAllCircles([]);
                }
            } catch (error) {
                console.error("Error fetching circles data:", error);
            }
        };

        fetchCirclesByZone();
    }, [selectedZone]);

    const displayNames = {
        totalGvps: "Total Route Points",
        totalhotspot: "Total Hotspots",
        uniqueGVPCleared: "Unique Route Points Cleared",
        totalClearedGVP: "Total Route Points Cleared",
        notClearedGvp: "Not Cleared Route Points ",
    };


    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF'];

    return (
        <div style={{ width: "100%" }}>
            <div className="content">
                <div className="page-content">
                    <h4 className="text-start mb-3"> Primary Collection Dashboard</h4>
                    <div className="card">
                        <div className="card-body">
                            <div className="row " style={{ textAlign: "justify" }}>
                                <div className="col-md-12">
                                    <form>
                                        <div className="row" style={{ textAlign: "justify" }}>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="startDate">From Date & Time</label>
                                                    <input
                                                        type="datetime-local"
                                                        className="form-control"
                                                        id="startDate"
                                                        name="startDate"
                                                        style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                                                        value={startDate}
                                                        onChange={(e) => setStartDate(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="endDate">To Date & Time</label>
                                                    <input
                                                        type="datetime-local"
                                                        className="form-control"
                                                        id="endDate"
                                                        name="endDate"
                                                        style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                                                        value={endDate}
                                                        onChange={(e) => {
                                                            // Check if end date is before start date
                                                            if (new Date(e.target.value) < new Date(startDate)) {
                                                                toast.warning("End date cannot be before start date");
                                                                return; // Don't update end date if it's invalid
                                                            }
                                                            setEndDate(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="ZoneId">Select Zone</label>
                                                    <select
                                                        type="text"
                                                        name="ZoneId"
                                                        className="form-select"
                                                        style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                                                        value={selectedZone}
                                                        onChange={(e) => {
                                                            if (e.target.value === "") {
                                                                // Clear selected circle and transfer station when "All Zones" is selected
                                                                setSelectedCircles("");
                                                            }
                                                            setSelectedZone(e.target.value);
                                                        }}
                                                    >
                                                        <option value="">All</option>
                                                        {allZones.filter((zone)=>zone.isActive).map((zone) => (
                                                            <option key={zone.zoneId} value={zone.zoneId}>
                                                                {zone.zoneName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="CircleId">Select Ward</label>
                                                    <select
                                                        type="text"
                                                        name="CircleId"
                                                        className="form-select"
                                                        style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                                                        value={selectedCircles}
                                                        onChange={(e) => {
                                                            setSelectedCircles(e.target.value);
                                                        }}
                                                    >
                                                        <option value="">All</option>
                                                        {allCircles?.map((circle) => (
                                                            <option
                                                                key={circle.circleId}
                                                                value={circle.circleId}
                                                                selected={circle.circleId === selectedCircles}
                                                            >
                                                                {circle.circleName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label className="form-label">Select Shift</label>
                                                    <select
                                                        value={selectedShift}
                                                        name="ShiftId"
                                                        className="form-select"
                                                        style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                                                        onChange={(e) => {
                                                            setSelectedShift(e.target.value);
                                                        }}
                                                    >
                                                        <option value="" >All</option>
                                                        {Array.isArray(shiftData) &&
                                                            shiftData.filter((shift)=>shift.isActive).map((shift) => (
                                                                <option
                                                                    key={shift.shiftId}
                                                                    value={shift.shiftId}
                                                                    selected={shift.shiftId === selectedShift}
                                                                >
                                                                    {shift.shiftName}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group"></div>
                                                <button
                                                    type="button"
                                                    className={`btn mt-2 ${isProd ? "search-ghmc" : "search-swm"}`}
                                                    onClick={handleSearch}
                                                >
                                                    Search
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    {isOptionsLoading && <Loader />}
                    <div className="row" style={{ textAlign: "justify" }}>
                        <div className="col-md-12" >
                            <div class="row g-3">
                                {Object.entries(gvpCountDashboard).map(([GVPDashboard, count]) => {
                                    const displayName = displayNames[GVPDashboard] || GVPDashboard;
                                    return (
                                        <div className="col-md-3">
                                            <div className="card shadow">
                                                <div className="card-body card_text_no">
                                                    <p className="card-title">{displayName}</p>
                                                    <h4 className="card-text">{count}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3" style={{ textAlign: "justify" }}>
                        <div className="col-md-12 me-auto">
                            <div className="card">
                                <div className="card-header text-center">
                                    Primary Collection Dashboard Chart
                                </div>
                                <div className="card-body p-3">
                                    {pieChartData.length > 0 ? (
                                        <PieChart width={700} height={400} className="mx-auto">
                                            <Pie
                                                dataKey="value"
                                                isAnimationActive={false}
                                                data={pieChartData}
                                                cx="50%"
                                                cy="50%"
                                                outerRadius={150}
                                                fill="#8884d8"
                                                label
                                            >
                                                {pieChartData.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                                ))}
                                            </Pie>
                                            <Tooltip />
                                            <Legend />
                                        </PieChart>
                                    ) : (
                                        <p style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold", }}>
                                            No Preview available as data does not exists
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GvpDashboardReport;
const getStartOfCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hour}:${minute}`;
};
